import { TableContainer, Paper, Typography } from '@mui/material';
import SuspenseLoader from 'components/SuspenseLoader';
import { FC } from 'react';
import { t } from 'i18next';
import DeviationListTable from './Table';
import NoResult from './NoResult';
import './DeviationList.scss';
import useDeviationList from './hooks/useDeviationList';

export const getStatusColorClasses = (
  status: boolean | null,
  confirmed: string | null,
): string => {
  if (confirmed) {
    return 'is-confirmed';
  }

  if (status) {
    return 'escape-risk';
  }

  return 'no-escape-risk';
};

const DeviationList: FC = (): JSX.Element => {
  const { holes, isFetching, error } = useDeviationList();

  return (
    <div className={`hole-table ${holes?.length ? 'items-with-result' : ''}`}>
      {isFetching ? (
        <TableContainer component={Paper} className="hole-list-table-container">
          <SuspenseLoader isFullScreen={false} />
        </TableContainer>
      ) : error ? (
        <TableContainer component={Paper} className="hole-list-table-container">
          <Typography>{t('An error occurred while loading data')}</Typography>
        </TableContainer>
      ) : holes?.length === 0 ? (
        <TableContainer component={Paper} className="hole-list-table-container">
          <NoResult />
        </TableContainer>
      ) : (
        <DeviationListTable holes={holes} />
      )}
    </div>
  );
};

export default DeviationList;
